import React from 'react'
import classes from "./Abt1.module.css"
import B from "./../../Asset/ofcourse.webp"
import c from "./../../Asset/gg.webp"
import A from "./../../Asset/world.webp"

const Abt1 = () => {
  return (
     <div>



    <div className={classes.Abt1}>

<h3 className={classes.hed}>Infisea set sail in 2024  </h3> 


<p  className={classes.Abtp}>During one of their many explorations, 

<br/>Our founders Mr. Abhishek sir discovered that
<br/> the dopest people of our land were in search of affordable, 
<br/> durable and ultra fashionable EMS products to groove to. 
</p>

<br/> <p  className={classes.Abtp}>Thus, in 2014, they kickstarted a great voyage in Indian consumer waters.</p>



<br/>
<br/> <p  className={classes.Abtp2}>The Aim Of This Journey ?</p>
Self discovery as an Indian,
<img src={B} />


<br></br><br></br>


 <p  className={classes.Abt1}>Meet our EMS enthusiast – a groove-loving, always-on-the-move individual, passionately driven to achieve their goals! Unleash the power of our EMS product and elevate your journey to new heights.</p>

<br/>

 <p  className={classes.Abtp2}>TOGETHER, WE ARE AN EVER-GROWING TRIBE OF</p>
<img src={c} />

</div>


<div className={classes.Abt1}>
<div className={classes.Abt12}> 
<h3 className={classes.hed}>Sailing across the nation and beyond</h3>
<img className={classes.Abti} src={A}/>
</div>

<div className={classes.Abt11}> 
 
<p  className={classes.Abtp}>&emsp;&emsp;Every Infisian out there is our anchor! Their love and support inspires us to never back down, even in turbulent waters and stormy seas. No wonder then, that we've sailed from strength to strength, even in a year like 2024.
</p>
</div>



<h3 className={classes.hed}>What's next? </h3>
<br/><p  className={classes.Abtp3}>All that has happened to us is overwhelming, yes, 
<br/>but it pushes us to do more, be more and make more 
<br/>products that you can use to jazz up your lifestyle.</p>
  
  <br/>
  <p  className={classes.Abtp3}>So, in 2024, we've started to fearlessly rock in India with a range of products that free-spirited Indians like you can truly call your own!</p>
 

 <p  className={classes.Abtp3}>MAKE IN INDIA</p>
<div className={classes.one}><span className={classes.orange}>BY AN</span> &nbsp; <span className={classes.white}>INDIAN</span>  &nbsp; <span className={classes.green}>BRAND</span></div> 

</div>
   
      </div>

  )
}

export default Abt1